import styled from 'styled-components';

const DivSelectLabels = styled.div`
  margin-left: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1rem;
  color: #00273F;
  font-weight: bold;
  margin-bottom: 10px;

`;


export default DivSelectLabels;
